import { Component, OnInit, AfterViewInit, AfterViewChecked, ViewChild, ElementRef, Input, Output, EventEmitter, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { DigitalesService } from '../../../shared/services/digitales.service';
import { AdministracionService } from '../../../shared/services/administracion.services';
import { Administracion } from '../../../shared/model/administracion.model';
import { HttpEventType } from '@angular/common/http';
declare var require: any;
const Swal = require('sweetalert2');

@Component({
  selector: 'app-firmas',
  templateUrl: './firmas.component.html',
  styleUrls: ['./firmas.component.scss']
})
export class FirmasComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  @ViewChild('signaturePad', { static: false }) signaturePadCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() cedula: string = '';
  @Input() firmaExistente: { ruta?: string } | null = null;
  @Output() firmaCargada = new EventEmitter<string>();

  private ctx: CanvasRenderingContext2D | null = null;
  private isDrawing = false;
  private lastX = 0;
  private lastY = 0;
  private canvasInicializado = false;

  // Opciones de firma
  modoFirma: 'dibujar' | 'cargar' = 'dibujar';
  archivoFirma: File | null = null;
  previewFirma: string | null = null;
  firmaCargadaUrl: string | null = null;

  // Estados
  guardando = false;
  mensajeError = '';
  administraciones: Administracion[] = [];
  private firmaFueLimpiada = false; // Flag para evitar consultar tras limpiar

  constructor(
    private digitalesService: DigitalesService,
    private administracionService: AdministracionService
  ) {}

  ngOnInit(): void {
    this.cargarDataAdmin();
    // Cargar firma existente si viene del modo edición
    if (this.firmaExistente) {
      this.cargarFirmaExistente();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Detectar cuando firmaExistente cambia (incluyendo el primer cambio)
    if (changes['firmaExistente']) {
      //console.log('🔄 ngOnChanges detectó cambio en firmaExistente:', changes['firmaExistente'].currentValue);
      this.cargarFirmaExistente();
    }
  }

  private cargarDataAdmin(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data;
      },
      error: (err) => {
        console.error('Error al cargar administración:', err);
      }
    });
  }

  /**
   * Cargar firma existente en modo edición
   * Muestra la firma en modo preview (cargar)
   */
  private cargarFirmaExistente(): void {
   // console.log('🔍 Intentando cargar firma existente:', this.firmaExistente);
    
    if (!this.firmaExistente || !this.firmaExistente.ruta) {
     // console.log('❌ No hay firma existente');
      return;
    }

    const ruta = this.firmaExistente.ruta;
   // console.log(`✅ Firma encontrada - Ruta: ${ruta}`);

    // Cargar en modo preview (por defecto)
   // console.log('📷 Cargando firma en modo PREVIEW');
    this.modoFirma = 'cargar';
    this.previewFirma = ruta;
    //console.log('✅ Preview URL establecida:', this.previewFirma);
    
    // Fetch la imagen para tener el archivo cargado
   // console.log('⏳ Intentando fetch de imagen desde:', ruta);
    fetch(ruta)
      .then(res => {
        // console.log(`📡 Respuesta fetch - Status: ${res.status}, OK: ${res.ok}`);
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return res.blob();
      })
      .then(blob => {
        // console.log(`✅ Blob recibido - Size: ${blob.size} bytes, Type: ${blob.type}`);
        this.archivoFirma = new File([blob], `FIRMA_${this.cedula}.png`, { type: 'image/png' });
        // console.log('✅ Archivo de firma cargado correctamente');
      })
      .catch(err => {
        console.error('❌ Error en fetch:', err);
        console.error(`   URL: ${ruta}`);
        console.error(`   Error type: ${err.message}`);
      });
  }

  /**
   * Cargar imagen de firma en el canvas
   */
  private cargarFirmaEnCanvas(rutaFirma: string): void {
   // console.log('🖼️ Intentando cargar imagen en canvas, ruta:', rutaFirma);
    
    if (!this.signaturePadCanvas) {
      console.error('❌ Canvas no disponible');
      return;
    }
    
    if (!this.ctx) {
      console.error('❌ Contexto 2D no disponible, intentando reinicializar');
      this.intentarInicializarCanvas();
      if (!this.ctx) {
        console.error('❌ No se pudo obtener contexto 2D');
        return;
      }
    }

    const canvas = this.signaturePadCanvas.nativeElement;
    const img = new Image();
    
    // Permite CORS si es necesario
    img.crossOrigin = 'anonymous';

    img.onload = () => {
     // console.log('✅ Imagen cargada exitosamente en memoria');
     // console.log(`📏 Dimensiones imagen: ${img.width}x${img.height}`);
     // console.log(`📏 Dimensiones canvas: ${canvas.width}x${canvas.height}`);
      
      // Limpiar canvas
      this.ctx!.fillStyle = '#FFFFFF';
      this.ctx!.fillRect(0, 0, canvas.width, canvas.height);
      
      // Dibujar imagen cargada
      this.ctx!.drawImage(img, 0, 0, canvas.width, canvas.height);
      //console.log('✅ Imagen dibujada en canvas');
    };

    img.onerror = (error: any) => {
      console.error('❌ Error cargando imagen:', error);
     // console.error(`   URL intentada: ${rutaFirma}`);
    };
    
    img.onabort = () => {
      console.warn('⚠️ Carga de imagen abortada');
    };

    //console.log('⏳ Iniciando carga de imagen desde URL...');
    img.src = rutaFirma;
  }

  ngAfterViewInit(): void {
    this.intentarInicializarCanvas();
  }

  ngAfterViewChecked(): void {
    this.intentarInicializarCanvas();
  }

  cambiarModo(modo: 'dibujar' | 'cargar'): void {
  
  
    this.modoFirma = modo;
    
    if (modo === 'dibujar') {
      // Cuando cambia a modo dibujar, limpiar todo primero
     
      this.archivoFirma = null;
      this.previewFirma = null;
      this.firmaCargadaUrl = null;
      this.mensajeError = '';
      this.canvasInicializado = false;
      this.ctx = null;
      
      // Si hay firma existente Y NO FUE LIMPIADA, cargarla en canvas
      if (!this.firmaFueLimpiada && this.firmaExistente?.ruta) {
       
        setTimeout(() => {
          this.intentarInicializarCanvas();
          this.cargarFirmaEnCanvas(this.firmaExistente!.ruta!);
        }, 200);
      } else {
        
     //   console.log('🖌️ Canvas limpio para nuevo dibujo');
        setTimeout(() => {
          this.intentarInicializarCanvas();
        }, 200);
      }
    } else if (modo === 'cargar') {
      // Cuando cambia a modo cargar, limpiar canvas completamente
      //console.log('🗑️ Limpiando canvas al cambiar a modo CARGAR');
      if (this.ctx && this.signaturePadCanvas) {
        const canvas = this.signaturePadCanvas.nativeElement;
        this.ctx.fillStyle = '#FFFFFF';
        this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
      
      // Si hay firma existente Y NO FUE LIMPIADA, mostrar su preview
      if (!this.firmaFueLimpiada && this.firmaExistente?.ruta) {
      //  console.log('📷 Mostrando preview de firma existente');
        this.previewFirma = this.firmaExistente.ruta;
      } else {
        if (this.firmaFueLimpiada) {
          console.log('⚠️ Firma fue limpiada - Listo para nueva firma');
        } else {
          console.log('📂 Listo para cargar nueva firma');
        }
        this.archivoFirma = null;
        this.previewFirma = null;
        this.firmaCargadaUrl = null;
        this.mensajeError = '';
      }
    }
  }

  private intentarInicializarCanvas(): void {
    if (this.canvasInicializado || this.modoFirma !== 'dibujar') return;
    if (!this.signaturePadCanvas) return;

    const canvas = this.signaturePadCanvas.nativeElement;
    if (!canvas || canvas.offsetWidth === 0 || canvas.offsetHeight === 0) return;

    this.initCanvas();
    this.canvasInicializado = true;
  }

  private initCanvas(): void {
    if (!this.signaturePadCanvas) {
      console.warn('Canvas no disponible aún');
      return;
    }
    
    const canvas = this.signaturePadCanvas.nativeElement;
    
    if (!canvas) {
      console.warn('Elemento canvas no encontrado');
      return;
    }
    
    this.ctx = canvas.getContext('2d');
    
    if (!this.ctx) {
      console.error('No se pudo obtener el contexto 2D del canvas');
      return;
    }

    // Configurar el canvas
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    
    // Configuración del estilo de dibujo
    this.ctx.strokeStyle = '#000000';
    this.ctx.lineWidth = 2;
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';

    // Fondo blanco
    this.ctx.fillStyle = '#FFFFFF';
    this.ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  startDrawing(event: MouseEvent | TouchEvent): void {
    if (!this.ctx) return;
    
    this.isDrawing = true;
    const coords = this.getCoordinates(event);
    this.lastX = coords.x;
    this.lastY = coords.y;
  }

  draw(event: MouseEvent | TouchEvent): void {
    if (!this.isDrawing || !this.ctx) return;
    
    event.preventDefault();
    const coords = this.getCoordinates(event);
    
    this.ctx.beginPath();
    this.ctx.moveTo(this.lastX, this.lastY);
    this.ctx.lineTo(coords.x, coords.y);
    this.ctx.stroke();
    
    this.lastX = coords.x;
    this.lastY = coords.y;
  }

  stopDrawing(): void {
    this.isDrawing = false;
  }

  @HostListener('document:mouseup')
  onDocumentMouseUp(): void {
    this.isDrawing = false;
  }

  @HostListener('document:touchend')
  onDocumentTouchEnd(): void {
    this.isDrawing = false;
  }

  @HostListener('document:touchcancel')
  onDocumentTouchCancel(): void {
    this.isDrawing = false;
  }

  private getCoordinates(event: MouseEvent | TouchEvent): { x: number; y: number } {
    const canvas = this.signaturePadCanvas.nativeElement;
    const rect = canvas.getBoundingClientRect();
    
    if (event instanceof MouseEvent) {
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      };
    } else {
      const touch = event.touches[0];
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top
      };
    }
  }

  limpiarFirma(): void {
    console.log('🗑️ Limpiando firma completamente...');
    console.log('   ⚠️ Marcando firma como limpiada - No se cargará anterior');
    
    // 🔹 Marcar que fue limpiada (para no cargar anterior al cambiar modo)
    this.firmaFueLimpiada = true;
    
    // 🔹 Limpiar firma existente
    this.firmaExistente = null;
    console.log('✅ Firma existente limpiada');
    
    // 🔹 Limpiar canvas (modo dibujo)
    if (this.ctx && this.signaturePadCanvas) {
      const canvas = this.signaturePadCanvas.nativeElement;
      this.ctx.fillStyle = '#FFFFFF';
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      console.log('✅ Canvas limpiado');
    }
    
    // 🔹 Limpiar archivo
    this.archivoFirma = null;
    console.log('✅ Archivo limpiado');
    
    // 🔹 Limpiar todos los previews
    this.previewFirma = null;
    this.firmaCargadaUrl = null;
    console.log('✅ Previews limpiados');
    
    // 🔹 Limpiar mensajes de error
    this.mensajeError = '';
    console.log('✅ Mensajes de error limpiados');
    
    console.log('✅ Firma completamente limpiada');
  }

  /**
   * Método público para limpiar la firma desde el componente padre
   */
  public limpiarFirmaCompleta(): void {
    console.log('🗑️ Limpiando firma completa desde componente padre...');
    this.firmaFueLimpiada = true;
    this.firmaExistente = null;
    this.limpiarFirma();
  }

  onArchivoSeleccionado(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    const tiposPermitidos = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!tiposPermitidos.includes(file.type)) {
      this.mensajeError = 'Solo se permiten archivos PNG, JPG o JPEG';
      return;
    }

    // Validar tamaño (máximo 2MB)
    if (file.size > 2 * 1024 * 1024) {
      this.mensajeError = 'El archivo no debe superar 2MB';
      return;
    }

    // ✅ Resetear flag al cargar nueva firma
    this.firmaFueLimpiada = false;
    console.log('✅ Flag de firma limpiada reseteado - Nuevas firmas se pueden ejecutar');
    
    this.archivoFirma = file;
    this.mensajeError = '';

    // Generar preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.previewFirma = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  // Verificar si hay una firma dibujada o cargada
  public tieneFirma(): boolean {
    if (this.modoFirma === 'dibujar') {
      // Verificar si el canvas tiene contenido (no está en blanco)
      if (!this.signaturePadCanvas || !this.ctx) return false;
      
      const canvas = this.signaturePadCanvas.nativeElement;
      const pixelBuffer = new Uint32Array(
        this.ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer
      );
      
      // Si todos los píxeles son blancos (0xFFFFFFFF), no hay firma
      return !pixelBuffer.every(color => color === 0xFFFFFFFF);
    } else {
      // Para modo cargar, verificar si hay archivo
      return this.archivoFirma !== null;
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      
      // Validar tipo de archivo
      const tiposPermitidos = ['image/png', 'image/jpeg', 'image/jpg'];
      if (!tiposPermitidos.includes(file.type)) {
        this.mensajeError = 'Solo se permiten archivos PNG, JPG o JPEG';
        return;
      }

      // Validar tamaño (máximo 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.mensajeError = 'El archivo no debe superar 2MB';
        return;
      }

      // ✅ Resetear flag al cargar nueva firma
      this.firmaFueLimpiada = false;
      console.log('✅ Flag de firma limpiada reseteado - Nuevas firmas se pueden ejecutar');

      this.archivoFirma = file;
      this.mensajeError = '';

      // Generar preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewFirma = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  async guardarFirma(silencioso: boolean = false): Promise<boolean> {
    if (!this.cedula) {
      if (!silencioso) {
        Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar primero el número de documento de la persona'
        });
      }
      return false;
    }

    if (!this.administraciones || this.administraciones.length === 0) {
      if (!silencioso) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información de la empresa'
        });
      }
      return false;
    }

    // Verificar si hay contenido para guardar
    if (!this.tieneFirma()) {
      // Si es silencioso (auto-save), retornar true para que no bloquee el flujo
      // La firma es opcional
      if (silencioso) {
        return true;
      }
      Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        text: 'No hay firma para guardar'
      });
      return false;
    }

    this.guardando = true;
    this.mensajeError = '';

    try {
      let file: File;

      if (this.modoFirma === 'dibujar') {
        // Convertir canvas a blob y luego a File
        if (!this.signaturePadCanvas) {
          throw new Error('Canvas no disponible');
        }
        
        const canvas = this.signaturePadCanvas.nativeElement;
        const blob = await new Promise<Blob>((resolve, reject) => {
          canvas.toBlob((b) => {
            if (b) resolve(b);
            else reject(new Error('Error al convertir canvas'));
          }, 'image/png');
        });
        
        // Nombre simple: FIRMA_cedula.png
        file = new File([blob], `FIRMA_${this.cedula}.png`, { type: 'image/png' });
      //  console.log(`📝 Guardando firma: FIRMA_${this.cedula}.png`);
      } else {
        // Usar archivo cargado
        if (!this.archivoFirma) {
          throw new Error('No hay archivo seleccionado');
        }
        // Nombre simple: FIRMA_cedula.png
        file = new File([this.archivoFirma], `FIRMA_${this.cedula}.png`, { type: this.archivoFirma.type });
        console.log(`📷 Guardando firma: FIRMA_${this.cedula}.png`);
      }

      // Construir la carpeta siguiendo el patrón: NIT/personas
      const nombreCarpeta = `${this.administraciones[0].nit}/personas`;
      
      // Prefijo simple sin tipo
      const prefijo = 'FIRMA';
      
      // Subir archivo usando el servicio de digitales y convertir a Promise
      return new Promise<boolean>((resolve, reject) => {
        this.digitalesService.subirArchivo(
          file,
          this.cedula,
          nombreCarpeta,
          this.cedula,
          prefijo
        ).subscribe({
          next: (event) => {
            if (event.type === HttpEventType.Response) {
              if (!silencioso) {
                Swal.fire({
                  icon: 'success',
                  title: 'Éxito',
                  text: 'Firma guardada correctamente'
                });
              }
              // No emitir la URL completa en la respuesta
              // Solo confirmar que se guardó correctamente
              
              // ✅ Resetear flag para permitir futuras limpiezas
              this.firmaFueLimpiada = false;
              
              this.guardando = false;
              resolve(true);
            }
          },
          error: (error) => {
            console.error('Error al guardar firma:', error);
            this.mensajeError = 'Error al guardar la firma. Intente nuevamente.';
            if (!silencioso) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la firma'
              });
            }
            this.guardando = false;
            reject(error);
          }
        });
      });
      
    } catch (error) {
      console.error('Error al guardar firma:', error);
      this.mensajeError = 'Error al guardar la firma. Intente nuevamente.';
      if (!silencioso) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo guardar la firma'
        });
      }
      this.guardando = false;
      return false;
    }
  }
}